// The assistant's "smike" mascot as an inline glyph that follows `currentColor`,
// so it works on ANY ground and inverts with its container (dark text -> dark
// smike, white text -> white smike). smike.svg is a fixed-black asset, so a
// plain <img> only shows on light grounds; this masks `bg-current` with the
// mascot shape instead. Pass sizing via className (e.g. "h-5 w-5").
export function SmikeGlyph({ className = "" }: { className?: string }) {
  return (
    <span
      aria-hidden
      className={`inline-block shrink-0 select-none bg-current ${className}`}
      style={{
        maskImage: "url(/assistant/smike.svg)",
        WebkitMaskImage: "url(/assistant/smike.svg)",
        maskSize: "contain",
        WebkitMaskSize: "contain",
        maskRepeat: "no-repeat",
        WebkitMaskRepeat: "no-repeat",
        maskPosition: "center",
        WebkitMaskPosition: "center",
      }}
    />
  );
}
